import { render } from "./MoyensDePaiements.vue?vue&type=template&id=54336bb3"
import script from "./MoyensDePaiements.vue?vue&type=script&lang=js"
export * from "./MoyensDePaiements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__